import React, { Component } from 'react'
import parse from 'html-react-parser'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'
import { signUpAction } from '../../reducers/sign-up/action.js'
import { connect } from 'react-redux'
import propTypes from './prop'
import { withSnackbar } from 'notistack'
import translator from '../../translate'
import { snackbarDispose } from '../../reducers/snackbar/action'
import moment from 'moment-timezone'
import SetPassword from './password-field'
import { track, init } from '@amplitude/analytics-browser'
import { styled } from '@material-ui/core/styles'
import Page from '../../components/Page'
import {
  Typography,
  FormControlLabel,
  Checkbox,
  Link,
  Grid,
  Box,
  Container,
  Card,
} from '@material-ui/core'
import { get as getCookie } from 'es-cookie'
import { CoreButton, CoreTextField } from 'src/components/core'

const RootStyle = styled(Page)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3),
  backgroundColor: '#fff',
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    padding: 0,
    paddingTop: '24px',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    bottom: '-20%',
    right: '-15%',
    width: '839px',
    height: '839px',
    borderRadius: '839px',
    background: 'linear-gradient(180deg, rgba(254, 225, 80, 0.50) 0%, rgba(225, 251, 255, 0.50) 100%)',
    filter: 'blur(200px)',
    zIndex: 0,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '-10%',
    right: '-10%',
    width: '467.584px',
    height: '467.584px',
    borderRadius: '467.584px',
    background: '#DFD0FF',
    filter: 'blur(229.20791625976562px)',
    zIndex: 0,
  },
}))

const FormCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  padding: '72px 48px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  borderRadius: '24px',
  background: '#FFF',
  boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
  width: '520px',
  maxWidth: '100%',
  borderTop: `6px solid ${theme.palette.primary.main}`,
  position: 'relative',
  zIndex: 2,
  [theme.breakpoints.down('md')]: {
    padding: '48px 24px',
  },
}))
class SignUp extends Component {
  state = {
    termsOfService: false,
    privacyPolicy: false,
    primaryRole: '',
    primaryInterest: '',
    showPassword: false,
    name: '',
    surName: '',
    shopName: '',
    password: '',
    disabled: true,
    ReceivesEmail: false,
  }

  /**
   *
   */
  onHandleSignUp = event => {
    event.preventDefault()
    const name = event.target.name.value
    const surName = event.target.surName.value
    const shopName = event.target.shopName.value
    const password = this.state.password
    //const purpose = event.target.purpose.value
    const emailConfirmationID =
      this.state.confirmationId != undefined ||
        this.state.confirmationId != null
        ? this.state.confirmationId
        : getCookie('confirmCode')
    const receivesEmail = this.state.ReceivesEmail
    /*     const primaryInterest = this.state.primaryInterest
    const marketingRole = this.state.primaryRole */
    const timeZone = moment.tz.guess()
    if (getCookie('email')) {
      init(process.env.REACT_APP_AMPLITUDE_KEY, getCookie('email'), {
        serverUrl: `${process.env.REACT_APP_URL}Analytics/Track`,
      })
      //track('signed_up')
    }
    const data = {
      name,
      surName,
      shopName,
      password,
      emailConfirmationID,
      receivesEmail,
      /*primaryInterest,
      marketingRole, */
      timeZone,
      //purpose,
    }
    this.props.dispatch(signUpAction(data))
  }

  /**
   *
   */
  setReceivesEmail = e => {
    this.setState({
      ReceivesEmail: !this.state.ReceivesEmail,
    })
  }
  /**
   *
   */
  setTermsOfService = e => {
    this.setState({
      termsOfService: !this.state.termsOfService,
    })
  }
  /**
   *
   */
  setPrivacyPolicy = e => {
    this.setState({
      privacyPolicy: !this.state.privacyPolicy,
    })
  }
  handleChangeRole = e => {
    this.setState({
      primaryRole: e.target.value,
    })
  }

  handleChangeInterest = e => {
    this.setState({
      primaryInterest: e.target.value,
    })
  }

  handleChangeShopName = shopName => {
    this.setState({
      shopName: shopName,
    })
  }

  handleChangeName = name => {
    this.setState({
      name: name,
    })
  }

  handleChangeSurName = surName => {
    this.setState({
      surName: surName,
    })
  }

  handleChangePassword = password => {
    this.setState({
      password: password,
    })
  }
  handleChangeDisable = disabled => {
    this.setState({
      disabled: disabled,
    })
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  /**
   *
   */
  render() {
    const { classes } = this.props
    const {
      name,
      surName,
      shopName,
      password,
      disabled,
    } = this.state

    let signUpButtonDisable = true
    if (
      shopName !== '' &&
      name !== '' &&
      surName !== '' &&
      password !== '' &&
      disabled == false
    ) {
      signUpButtonDisable = false
    } else {
      signUpButtonDisable = true
    }

    return (
      <RootStyle title="Sign Up | Mini-Course Generator">
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>

          {/* Blue Blur Blob */}
          <Box
            sx={{
              position: 'absolute',
              top: '3%',
              right: '20%',
              width: '300px',
              height: '300px',
              background: '#0094FF',
              filter: 'blur(150px)',
              borderRadius: '9999px',
              zIndex: -1,
              opacity: 0.6,
            }}
          />

          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <FormCard>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', mb: { xs: '24px', md: '32px' } }}>
                <Box component="img" src="/assets/mcg-icon.svg" sx={{ width: 40, height: 40 }} />
                <Box component="img" src="/assets/mcg-text.svg" sx={{ width: '162.667px', height: 40 }} />
              </Box>

              <Typography sx={{
                color: '#002E47',
                fontFamily: 'Inter',
                fontSize: { xs: '24px', md: '32px' },
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: '150%',
                mb: 3
              }}>
                Set Up Your Account
              </Typography>

              <form onSubmit={this.onHandleSignUp} style={{ width: '100%' }}>
                <Grid container spacing={2} style={{ marginBottom: '16px' }}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ mb: 0, fontWeight: 600 }}>
                      Company Name <span style={{ color: '#ED4245' }}>*</span>
                    </Typography>
                    <CoreTextField
                      required
                      fullWidth
                      marginTop={false}
                      id="shopName"
                      placeholder="Company or project name"
                      name="shopName"
                      onChange={value => { this.handleChangeShopName(value) }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" sx={{ mb: 0, fontWeight: 600 }}>
                      First Name <span style={{ color: '#ED4245' }}>*</span>
                    </Typography>
                    <CoreTextField
                      autoComplete="fname"
                      name="name"
                      required
                      fullWidth
                      marginTop={false}
                      id="name"
                      placeholder="First name"
                      autoFocus
                      onChange={value => { this.handleChangeName(value) }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" sx={{ mb: 0, fontWeight: 600 }}>
                      Last Name <span style={{ color: '#ED4245' }}>*</span>
                    </Typography>
                    <CoreTextField
                      required
                      fullWidth
                      marginTop={false}
                      id="surName"
                      placeholder="First name"
                      name="surName"
                      onChange={value => { this.handleChangeSurName(value) }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ mb: 0, fontWeight: 600 }}>
                      Password <span style={{ color: '#ED4245' }}>*</span>
                    </Typography>
                    <SetPassword
                      password={password}
                      handleChangePassword={this.handleChangePassword}
                      disabled={disabled}
                      handleChangeDisable={this.handleChangeDisable}
                    />
                  </Grid>

                  <Grid item xs={12} sx={{ mt: 2, mb: 2 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          value={this.state.ReceivesEmail}
                          color="primary"
                          name="ReceivesEmail"
                          id="ReceivesEmail"
                          onChange={this.setReceivesEmail}
                          checked={this.state.ReceivesEmail}
                        />
                      }
                      label={translator._('signUp.iWantToReceiveMarketing')}
                    />
                  </Grid>
                </Grid>
                <CoreButton
                  type="submit"
                  fullWidth
                  disabled={signUpButtonDisable}
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{ height: '48px', padding: '15px 22px' }}
                >
                  {translator._('signUp.signUp')}
                </CoreButton>
                <Box sx={{ textAlign: 'center', mt: 2 }}>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {translator._('signUp.alreayHaveAnAccount')}{' '}
                    <Link href="/login" variant="subtitle2" sx={{ color: '#015ffb', fontWeight: 'bold' }}>
                      Sign In
                    </Link>
                  </Typography>
                </Box>
              </form>
            </FormCard>
          </Box>
        </Container>
        <img src="https://ct.capterra.com/capterra_tracker.gif?vid=2200343&vkey=f0d1ebbfbb1b0efe0b4949da260fe34b" style={{ position: 'absolute', width: 0, height: 0 }} />
      </RootStyle>
    )
  }

  /**
   *
   */
  componentWillMount() {
    const { match } = this.props
    var id = match.params.id
    this.setState({
      confirmationId: id,
    })
  }

  /**
   *
   */
  componentDidUpdate() {
    const { snackbar, enqueueSnackbar, dispatch } = this.props
    if (snackbar.messages) {
      snackbar.messages.forEach(message => {
        message.messageIds.forEach(messageId => {
          enqueueSnackbar(translator._(messageId), {
            preventDuplicate: true,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
          })
        })
        dispatch(snackbarDispose(message.id))
      })
    }
  }
}

SignUp.propTypes = propTypes

const mapStateToProps = response => ({
  snackbar: response.snackbar,
})

export default connect(mapStateToProps)(
  withStyles(styles)(withSnackbar(SignUp)),
)
